/* Normalize legacy editor markup without changing policy wording. */
(() => {
  document.querySelectorAll('.gm-policy-copy').forEach((copy) => {
    copy.querySelectorAll('p,li').forEach((element) => {
      // Blank trailing lines used to compound the theme's paragraph margins.
      while (element.lastChild && (element.lastChild.nodeName === 'BR' ||
        (element.lastChild.nodeType === 3 && !element.lastChild.textContent.trim()))) {
        element.lastChild.remove();
      }
    });
    copy.querySelectorAll('p').forEach((paragraph) => {
      const text = paragraph.textContent.trim();
      if (!text) { paragraph.remove(); return; }
      const mainHeading = /^第[0-9０-９]+条/.test(text) ||
        /^(1\. 返品・交換について|2\. ご注文のキャンセルについて)$/.test(text);
      const subHeading = /^【[^】]+】$/.test(text) || text === '5. 広告配信事業者への提供';
      if (mainHeading || subHeading) {
        const heading = document.createElement(mainHeading ? 'h2' : 'h3');
        heading.innerHTML = paragraph.innerHTML;
        paragraph.replaceWith(heading);
      } else if (/^[0-9０-９]+[.．]/.test(text)) {
        paragraph.classList.add('gm-policy-copy__item');
      } else if (/^[-−]/.test(text)) {
        paragraph.classList.add('gm-policy-copy__subitem');
      } else if (/^【[^】]+】/.test(text)) {
        paragraph.classList.add('gm-policy-copy__note');
      }
    });
    // Terms were authored with h3 for top-level articles.
    copy.querySelectorAll('h3').forEach((heading) => {
      if (!/^第[0-9０-９]+条/.test(heading.textContent.trim())) return;
      const replacement = document.createElement('h2');
      replacement.innerHTML = heading.innerHTML;
      heading.replaceWith(replacement);
    });
  });
})();
